import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngRowDetail extends ngCellEx
{
	constructor () {
		super();

		this.applyBaseStyle();
	}

	connectedCallback() {

		this.shadowRoot.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="dtl" focusable="false" aria-hidden="true">
				<path d="M10 2h4v4"></path>
				<path d="m6 10 8-8"></path>
				<path d="M14 9.048V14H2V2h5"></path>
			</svg>
		`;

		super.connectedCallback();
		
		this.#init();
	};
	
	dataRefresh = (v) => {
		if (!this.owner || !this.cell || !this.data) return;
		
		if (!v) this.reset();
	};
	
	#init = () => {
		this.shadowRoot.querySelector("svg.dtl").addEventListener("click", e => {
			$('ng-row-detail-popup', this.owner.shadowRoot).remove();
			$(this.owner.shadowRoot).append($('<ng-row-detail-popup></ng-row-detail-popup>'));
			this.owner.shadowRoot.querySelector("ng-row-detail-popup").popup(this.cell.dataset.row);
		});
	}
}


class ngRowDetailPopup extends HTMLElement
{
	#owner;
	#grd;
	#rowIndex;
	
	constructor() {
	
		super();

		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		
		this.#owner = this.getRootNode().host;//this.closest("nine-grid");

		const cssPath = this.#owner.getAttribute("css-path") || "";
		
		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/ninegrid.css";
				nine-grid {
					border: 1px solid #ccc;
				}
			</style>
			
			<nx-dialog>
				<nine-grid css-path="${cssPath}" display-row-count="1" class="simple detail" select-type="cell" auto-fit-col="true" col-indicator-type="collapse">
					<table style="display: none;">
						<colgroup>
						</colgroup>
						<tbody>
						</tbody>
					</table>
				</nine-grid>
			</nx-dialog>
		`;

		this.#grd = this.shadowRoot.querySelector("nine-grid");
		
		this.#grd.fields.add(this.#owner.fields.get());
		/**
		$(this.shadowRoot.querySelector("dialog")).css({
			height: 0,
		});
					
		setTimeout(() => {
			const h = $(this.#grd).height() + 50;
			$(this.shadowRoot.querySelector("dialog")).css({
				height: h,
			}).height(h);
		}, 500); */
		
		
		//$(".ng-table", this.#grd.body).on("wheel", this.___onWheel);
		
		$(".reset", this.shadowRoot).on("click", e => {
			//this.#grd.dataSource = [Object.assign({}, this.#owner.data.get(this.#row))];
			this.#grd.data.set(this.#owner.data.getNF(this.#rowIndex));
		});
		
		$(".apply", this.shadowRoot).on("click", e => {
			this.#owner.data.all.update(this.#grd.data.get(0), this.#rowIndex);
			this.shadowRoot.querySelector('dialog').close();
		});
		
		$(".close", this.shadowRoot).onFirst("click", e => {
					
			if (!this.#grd.data.isChanged()) return;

			e.stopImmediatePropagation();
			
			ninegrid.confirm("There is changed data.\nDo you want to save it?", "SAVE", {"class": "rgb", "true-text": "Yes", "false-text": "No", }).then(result => {

				if (result) {
					$(".apply", this.shadowRoot).trigger("click");
				}
				
				this.shadowRoot.querySelector("nx-dialog").close();
			});
		});
		//this.#init();
	}
	
	popup = (row) => {

		var data = this.#owner.body.querySelector(`tr[data-row="${row}"]`).data;

		this.#rowIndex = data.__ng._[ninegrid.ROW.INDEX];
	
		$(".title", this.shadowRoot).html(this.#owner.getAttribute("caption") || "Details");
		$(".sub-title", this.shadowRoot).html(`(${(Number(row)+1).toLocaleString()} of ${this.#owner.data.count().toLocaleString()})`);
		
		/**
		 * colgroup
		 */
		var colgroup = $("colgroup", this.#grd);//$("<colgroup></colgroup>");
		var maxWidth = 500;
		var colCount = $(".ng-container-body thead tr", this.#owner.body).not(".col-indicator-rowgroup").length;
		var colCount2 = this.#owner.template.length;
	
		var rowCount = 0;
		$(`tr [data-row=${row}]`, this.#owner.body).not(".dummy").not(".first").not(".last").each((i,td) => {
			rowCount = Math.max(rowCount, parseInt(td.getAttribute("data-col")) + parseInt(td.getAttribute("colspan") || 1));
		});
		
		for (var i = 0; i < colCount; i++) {
			var w = maxWidth * 0.3 / colCount;
			colgroup.append(`<col width="${w}" />`);
		}
		
		for (var i = 0; i < colCount2; i++) {
			var w = maxWidth * 0.7 / colCount2;
			colgroup.append(`<col width="${w}" />`);
		}

		for (var i = 0; i < rowCount; i++) {
			let tr = $("<tr></tr>");//.height(32);
			//tr[0].style.height = "32px";
			
			for (var j = 0; j < colCount; j++) {
				//var cell = $(`thead [data-col="${i}"]`, this.#owner.body).not(".dummy").not(".first").not(".last").not(".col-indicator").eq(j);
				const cell = this.#owner.body.querySelectorAll(`thead [data-col="${i}"]:not(.dummy):not(.first):not(.last):not(.col-indicator)`)[j];
				//console.log(cell, j, this.#owner.body.querySelectorAll(`thead [data-col="${i}"]:not(.dummy):not(.first):not(.last):not(.col-indicator)`));
				
				if (cell) {
					const colspan = cell.getAttribute("rowspan") || 1;
					const rowspan = cell.getAttribute("colspan") || 1;
					
					const node = cell.cloneNode(true);
					node.setAttribute("rowspan", rowspan);
					node.setAttribute("colspan", colspan);
					node.removeAttribute("fixed");
					$(node).height($(cell).height());
					//$(node).height(32);
					
					//console.log(node);
					tr.append(node);
					
					//tr.append(cell.cloneNode(true).setAttribute("rowspan", rowspan).attr("colspan", colspan).removeAttr("fixed")).height($(cell).height() + 1);
				}
			}
			
			for (var j = 0; j < colCount2; j++) {
				//var cell = $(`[data-row="${row}"][data-col="${i}"]`, this.#owner.body).not(".dummy").not(".first").not(".last").eq(j);
				const cell = this.#owner.body.querySelectorAll(`[data-row="${row}"][data-col="${i}"]:not(.dummy):not(.first):not(.last)`)[j];
				if (cell) {
					const colspan = cell.getAttribute("rowspan") || 1;
					const rowspan = cell.getAttribute("colspan") || 1;
					
					/**
					 * 성세창 연결 시 <ng-row-indicator>, <ng-row-state>, <ng-row-pin>, <ng-row-detail> 등의 컴포넌트는 제외한다.
					 */
					if ($("ng-row-indicator,ng-row-state,ng-row-pin,ng-row-detail", cell).length > 0) {
						tr = null;
						break;
					}
					
					const node = cell.cloneNode(true);
					node.setAttribute("data-row", 0);
					node.setAttribute("rowspan", rowspan);
					node.setAttribute("colspan", colspan);
					node.removeAttribute("fixed");
					//$(node).height($(cell).height());
					
					tr.append(node);
					
					//tr.append(cell.clone().attr("data-row", 0).attr("rowspan", rowspan).attr("colspan", colspan).removeAttr("fixed"));
					for (const child of cell.children) {
						
						const dataSource = child.getAttribute("data-source");
						if (dataSource) {
							this.#grd[dataSource] = this.#owner[dataSource];
						}
					}
				}
			}
			
			if (tr && tr.html()) $("tbody.bindable tr.nodata", this.#grd.shadowRoot).before(tr);
		}
		
		$("ng-row-indicator", this.#grd).closest("tr").remove();
		
		var col = 0;
		$("tbody.bindable tr:not(.nodata)", this.#grd.shadowRoot).each((i,tr)=> {
			$("th,td", tr).each((j,td)=> {
				td.dataset.col = col;
				col += (td.colSpan || 1);
			});
		});
		
		this.#grd.shadowRoot.querySelector(".ng-body").style.height = "100vh";
		
		this.#grd.createTemplate();
		
		this.shadowRoot.querySelector('dialog').showModal();

		setTimeout(() => {
			this.#grd.data.source = [Object.assign({}, this.#owner.data.getNF(this.#rowIndex))];
		});
	};
}


if (!customElements.get('ng-row-detail')) {
	customElements.define("ng-row-detail", ngRowDetail);
}

if (!customElements.get('ng-row-detail-popup')) {
	customElements.define("ng-row-detail-popup", ngRowDetailPopup);
}

